<template>
    <div ref="dropZoneElement">
        <div class="img-wrap dropzone dropzone-previews">
            <div class="formItem" v-for="(image, index) in localValue" :key="image.id" :class="{'formError' : error}">
                <div @click="showGallery(image)">
                    <label v-show="index==0">{{ label }}
                        <span v-if="subLabel"> ({{ subLabel }})</span>
                    </label>
                    <div class="img icon-search">
                        <img :src="getImageUrl(image)"/>
                        <span>
                        <button class="btn-icon-only icon-trash-small"
                                v-if="!readonly && !loading"
                                @click.stop.prevent="removeImage(index)"></button>
                            <v-text-field
                                    solo
                                    flat
                                    hide-details
                                    class="sr-input"
                                    @click.stop
                                    :label="label"
                                    :value="getImageTitle(image)"
                                    @input="setImageTitle(image, $event)"
                                    :disabled="loading || readonly"
                                    :readonly="loading || readonly"
                            ></v-text-field>
                        </span>
                    </div>
                </div>

            </div>
        </div>
        <div class="formItem" v-if="!readonly" :class="{'formError' : error}">
            <label v-show="!localValue.length">{{ label }}
                <span v-if="subLabel"> ({{ subLabel }})</span>
            </label>
            <div class="droparea">

                <i class="icon-plus"></i>
                Bilder hier ablegen
                <v-progress-circular v-if="isUploading === true"
                                     :size="16"
                                     :width="2"
                                     color="#2ED1DF"
                                     indeterminate></v-progress-circular>
            </div>
        </div>
    </div>
</template>

<script>
  import Dropzone from 'dropzone'
  import Vue from 'vue'

  Dropzone.autoDiscover = false
  export default {
    props: {
      error: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      label: {
        type: String
      },
      subLabel: {
        type: String,
        default: ''
      },
      value: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        isUploading: false,
        dropzone: null,
        dropzoneSettings: {
          uploadMultiple: true,
          acceptedFiles: 'image/*',
          parallelUploads: 1
        }
      }
    },
    mounted () {
      if (this.readonly) {
        return
      }
      this.dropzone = new Dropzone(this.$refs.dropZoneElement, this.getDropZoneSettings)
      this.dropzone.on('addedfile', (file) => {
        this.isUploading = true
      }).on('complete', (file) => {
        if (typeof file.xhr !== 'undefined' && typeof file.xhr.response !== 'undefined') {
          let r = JSON.parse(file.xhr.response)
          if (r.status === 'ok') {
            for (let i = 0; i < r.tmpFiles.length; i++) {
              this.value.push({
                hash: r.tmpFiles[i],
                uuid: file.upload.uuid,
                title: file.name
              })
            }
          }
        }
        this.valueChanged()
      }).on('error', (file) => {
        if (!file.accepted) {
          this.dropzone.removeFile(file)
        }
      }).on('queuecomplete', () => {
        this.isUploading = false
      })
    },
    beforeDestroy () {
      if (this.dropzone) {
        this.dropzone.destroy()
      }
    },
    methods: {
      showGallery (image) {
        this.$dialog.gallery({
          images: this.localValue,
          activeImage: image,
          dropzoneFiles: this.dropzone.files
        })
      },
      valueChanged () {
        this.$emit('input', this.localValue)
      },
      removeImage (index) {
        this.localValue.splice(index, 1)
        this.valueChanged()
      },
      getImageUrl (image) {
        if (image.url) {
          return image.url
        }
        if (this.dropzone && this.dropzone.files && image.uuid) {
          let obj = this.dropzone.files.find(obj => obj.upload.uuid === image.uuid)
          if (typeof obj !== 'undefined') {
            return obj.dataURL
          }
        }

        return ''
      },
      setImageTitle (image, value) {
        if (typeof image.title !== 'undefined') {
          return Vue.set(image, 'title', value)
        }

        if (this.dropzone && this.dropzone.files && image.uuid) {
          let obj = this.dropzone.files.find(obj => obj.upload.uuid === image.uuid)
          if (typeof obj !== 'undefined') {
            obj.title = value
          }
        }
      },
      getImageTitle (image) {
        if (typeof image.title !== 'undefined' && image.title) {
          return image.title
        }
        if (this.dropzone && this.dropzone.files && image.uuid) {
          let obj = this.dropzone.files.find(obj => obj.upload.uuid === image.uuid)
          if (typeof obj !== 'undefined') {
            return typeof obj.title !== 'undefined' ? obj.title : obj.name
          }
        }
        return ''
      }
    },
    computed: {
      localValue: {
        get () {
          return this.value || []
        },
        set (value) {
          this.$emit('input', value)
        }
      },
      getDropZoneSettings () {
        let settings = this.dropzoneSettings
        settings.url = process.env.VUE_APP_API_ENDPOINT + 'file/upload'
        settings.headers = { 'X-Session-Id': this.$store.getters['auth/getSessionId'] }
        settings.clickable = [this.$el.querySelector('.droparea')]
        settings.previewsContainer = false
        return settings
      }
    }
  }
</script>
